export const HOME = {
  emergentLink: "home-emergent-link",
};

export const GPS = {
  map: "gps-map",
  filterDropdown: "filter-dropdown",
  radiusSelector: "radius-selector",
  layoutToggle: "toggle-layout-btn",
  businessStrip: "business-strip",
  businessTab: "business-tab",
  adsPanel: "ads-panel",
  adsPanelClose: "ads-panel-close",
  navPanel: "nav-panel",
  navPanelClose: "nav-panel-close",
  recenterBtn: "recenter-btn",
  themeBtn: "map-theme-btn",
  locationBtn: "set-location-btn",
  useGpsBtn: "use-gps-btn",
  locationSearchInput: "location-search-input",
  locationSearchSubmit: "location-search-submit",
  locationResult: "location-result",
  bizDashboardBtn: "business-dashboard-btn",
  driveBtn: "drive-toggle-btn",
  postDealToggle: "post-deal-toggle",
  dealTitle: "deal-title-input",
  dealDetail: "deal-detail-input",
  dealDiscount: "deal-discount-input",
  dealExpires: "deal-expires-input",
  dealSubmit: "deal-submit-btn",
  askBtn: "ask-airpog-btn",
  askInput: "ask-airpog-input",
  askSubmit: "ask-airpog-submit",
  askPanel: "ask-airpog-panel",
  askPanelClose: "ask-airpog-close",
  askResult: "ask-airpog-result",
};
